import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/oreetiene/test.adi-mag.ro/components/othersPages/contact/ContactForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/oreetiene/test.adi-mag.ro/node_modules/lucide-react/dist/esm/Icon.mjs");
